/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { request } from "../request";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

const Order = () => {
  const { setCart, cart } = useContext(CartContext);
  const navigate = useNavigate();

  const phoneNumberRegex = /^(\+998|998)?[7-9][0-9]{8}$/;
  const [phoneNumber, setPhoneNumber] = useState("+998");
  const [validNumber, setValidNumber] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
  });
  const [products, setProducts] = useState([]);
  const [success, setSuccess] = useState("");

  // Validation errors
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    address: "",
    phoneNumber: "",
  });

  const [touched, setTouched] = useState({
    firstName: false,
    lastName: false,
    address: false,
    phoneNumber: false,
  });

  const validateField = (name, value) => {
    let errorMsg = "";

    switch (name) {
      case "firstName":
        if (!value.trim()) {
          errorMsg = "Имя обязательно для заполнения";
        } else if (value.trim().length < 2) {
          errorMsg = "Имя должно содержать минимум 2 символа";
        } else if (!/^[а-яА-ЯёЁa-zA-Z\s-]+$/.test(value)) {
          errorMsg = "Имя может содержать только буквы, пробелы и дефисы";
        }
        break;

      case "lastName":
        if (!value.trim()) {
          errorMsg = "Фамилия обязательна для заполнения";
        } else if (value.trim().length < 2) {
          errorMsg = "Фамилия должна содержать минимум 2 символа";
        } else if (!/^[а-яА-ЯёЁa-zA-Z\s-]+$/.test(value)) {
          errorMsg = "Фамилия может содержать только буквы, пробелы и дефисы";
        }
        break;

      case "address":
        if (!value.trim()) {
          errorMsg = "Адрес обязателен для заполнения";
        } else if (value.trim().length < 10) {
          errorMsg = "Адрес должен содержать минимум 10 символов";
        }
        break;

      case "phoneNumber":
        if (!value.trim()) {
          errorMsg = "Номер телефона обязателен";
        } else if (value.length < 13) {
          errorMsg = `Введите полный номер (${13 - value.length} цифр осталось)`;
        } else if (!phoneNumberRegex.test(value)) {
          errorMsg = "Неверный формат номера телефона";
        }
        break;

      default:
        break;
    }

    return errorMsg;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (touched[name]) {
      const errorMsg = validateField(name, value);
      setErrors({
        ...errors,
        [name]: errorMsg,
      });
    }
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value;

    if (!value.startsWith('+998')) {
      value = '+998';
    }

    const prefix = '+998';
    const digitsOnly = value.slice(prefix.length).replace(/\D/g, '');
    const limitedDigits = digitsOnly.slice(0, 9);
    const newValue = prefix + limitedDigits;

    setPhoneNumber(newValue);

    if (touched.phoneNumber) {
      const errorMsg = validateField("phoneNumber", newValue);
      setErrors({
        ...errors,
        phoneNumber: errorMsg,
      });
    }
  };

  const handlePhoneKeyDown = (e) => {
    const cursorPosition = e.target.selectionStart;

    if ((e.key === 'Backspace' || e.key === 'Delete') && cursorPosition <= 4) {
      e.preventDefault();
    }

    if (cursorPosition < 4 && e.key !== 'ArrowRight' && e.key !== 'Tab') {
      e.preventDefault();
    }
  };

  const handlePhoneFocus = (e) => {
    setTimeout(() => {
      const input = e.target;
      if (input.value === '+998') {
        input.setSelectionRange(4, 4);
      }
    }, 0);
  };

  const handlePhoneClick = (e) => {
    const input = e.target;
    if (input.selectionStart < 4) {
      input.setSelectionRange(4, 4);
    }
  };

  const handleBlur = (name) => {
    const value = name === "phoneNumber" ? phoneNumber : formData[name];

    const hasValue = name === "phoneNumber"
      ? phoneNumber.length > 4
      : value.trim().length > 0;

    if (hasValue) {
      setTouched({
        ...touched,
        [name]: true,
      });

      const errorMsg = validateField(name, value);
      setErrors({
        ...errors,
        [name]: errorMsg,
      });
    }
  };

  useEffect(() => {
    const result = phoneNumberRegex.test(phoneNumber);
    setValidNumber(result);
  }, [phoneNumber]);

  useEffect(() => {
    if (cart.length) {
      const updatedProducts = cart.map((item) => ({
        count: item.amount,
        id: item.id,
        info: {
          id: item.id,
          category: {
            id: item.category.id,
            category_name: item.category.category_name,
            image: item.category.image,
          },
          color: {
            id: item.color.id,
            color_code: item.color.color_code,
            color_name: item.color.color_name,
          },
          name: item.name,
          brand: item.brand,
          description: item.description,
          price: item.price,
          thumbnail: item.thumbnail,
          stock: item.stock,
          created_at: item.created_at,
          updated_at: item.updated_at,
        },
      }));
      setProducts(updatedProducts);
    } else {
      setProducts([]);
    }
  }, [cart]);

  const isFormValid = () => {
    return (
      !errors.firstName &&
      !errors.lastName &&
      !errors.address &&
      !errors.phoneNumber &&
      formData.firstName.trim() &&
      formData.lastName.trim() &&
      formData.address.trim() &&
      validNumber
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      firstName: true,
      lastName: true,
      address: true,
      phoneNumber: true,
    });

    const newErrors = {
      firstName: validateField("firstName", formData.firstName),
      lastName: validateField("lastName", formData.lastName),
      address: validateField("address", formData.address),
      phoneNumber: validateField("phoneNumber", phoneNumber),
    };

    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error !== "");
    if (hasErrors || cart.length === 0) {
      return;
    }

    try {
      const req = await request.post("/cart/", {
        firstname: formData.firstName,
        lastname: formData.lastName,
        phone_number: phoneNumber,
        address: formData.address,
        products: products,
      });

      if (req.status === 200 || req.status === 201) {
        setSuccess("Ваш заказ принят, мы свяжемся с вами в ближайшее время!");

        // Очистка формы и корзины
        setFormData({ firstName: "", lastName: "", address: "" });
        setPhoneNumber("+998");
        setCart([]);
        setTouched({ firstName: false, lastName: false, address: false, phoneNumber: false });
        setErrors({ firstName: "", lastName: "", address: "", phoneNumber: "" });

        // Перенаправление на главную через 2 секунды
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 2000);
      }
    } catch (err) {
      console.error("Ошибка при отправке заказа:", err);
    }
  };

  // Автоочистка сообщения об успехе (на всякий случай)
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <div className="container py-20 mx-auto md:mt-auto">
      {/* Success Message */}
      {success && (
        <div className="success-message mx-auto max-w-2xl mb-8 p-4 bg-gradient-to-r from-purple-500/20 to-purple-400/20 border-2 border-purple-400 rounded-xl text-center backdrop-blur-sm">
          <div className="flex items-center justify-center gap-3">
            <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p className="md:text-2xl text-xl text-purple-400 font-semibold">{success}</p>
          </div>
        </div>
      )}

      {/* Form Container */}
      <div className="max-w-4xl mx-auto">
        <h1 className="form-title text-4xl md:text-5xl font-bold text-center mb-10">
          Оформление заказа
        </h1>

        <div className="form-container card-hover rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* First Name */}
            <div className="input-group">
              <label htmlFor="firstName" className="label-text block text-sm font-semibold text-gray-200 mb-2">
                Имя <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  onBlur={() => handleBlur("firstName")}
                  className={`order-input p-4 text-white rounded-xl w-full text-lg ${errors.firstName && touched.firstName ? "error" : ""
                    } ${!errors.firstName && touched.firstName && formData.firstName ? "success" : ""}`}
                  placeholder="Введите ваше имя"
                />
                {!errors.firstName && touched.firstName && formData.firstName && (
                  <div className="phone-indicator">
                    <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                )}
              </div>
              {errors.firstName && touched.firstName && (
                <p className="error-text text-red-500 text-sm mt-2 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  {errors.firstName}
                </p>
              )}
            </div>

            {/* Last Name */}
            <div className="input-group">
              <label htmlFor="lastName" className="label-text block text-sm font-semibold text-gray-200 mb-2">
                Фамилия <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  onBlur={() => handleBlur("lastName")}
                  className={`order-input p-4 text-white rounded-xl w-full text-lg ${errors.lastName && touched.lastName ? "error" : ""
                    } ${!errors.lastName && touched.lastName && formData.lastName ? "success" : ""}`}
                  placeholder="Введите вашу фамилию"
                />
                {!errors.lastName && touched.lastName && formData.lastName && (
                  <div className="phone-indicator">
                    <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                )}
              </div>
              {errors.lastName && touched.lastName && (
                <p className="error-text text-red-500 text-sm mt-2 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  {errors.lastName}
                </p>
              )}
            </div>

            {/* Address */}
            <div className="col-span-1 md:col-span-2 input-group">
              <label htmlFor="address" className="label-text block text-sm font-semibold text-gray-200 mb-2">
                Адрес доставки <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  onBlur={() => handleBlur("address")}
                  className={`order-input p-4 text-white rounded-xl w-full text-lg ${errors.address && touched.address ? "error" : ""
                    } ${!errors.address && touched.address && formData.address ? "success" : ""}`}
                  placeholder="Например: г. Ташкент, ул. Амира Темура, д. 12, кв. 5"
                />
                {!errors.address && touched.address && formData.address && (
                  <div className="phone-indicator">
                    <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                )}
              </div>
              <div className="flex justify-between items-center mt-1">
                {errors.address && touched.address && (
                  <p className="error-text text-red-500 text-sm mt-1 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    {errors.address}
                  </p>
                )}
                <p className={`char-counter ml-auto ${formData.address.length < 10 ? 'text-gray-500' : 'text-purple-400'}`}>
                  {formData.address.length} / 10 мин
                </p>
              </div>
            </div>

            {/* Phone Number */}
            <div className="col-span-1 md:col-span-2 input-group">
              <label htmlFor="phoneNumber" className="label-text block text-sm font-semibold text-gray-200 mb-2">
                Номер телефона <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={phoneNumber}
                  onChange={handlePhoneChange}
                  onKeyDown={handlePhoneKeyDown}
                  onFocus={handlePhoneFocus}
                  onClick={handlePhoneClick}
                  onBlur={() => {
                    handleBlur("phoneNumber");
                  }}
                  className={`order-input p-4 text-white rounded-xl w-full text-lg pr-12 ${errors.phoneNumber && touched.phoneNumber ? "error" : ""
                    } ${validNumber && touched.phoneNumber ? "success" : ""}`}
                  placeholder="+998 XX XXX XX XX"
                  maxLength="13"
                />
                <div className="phone-indicator">
                  {validNumber ? (
                    <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  ) : phoneNumber.length > 4 && touched.phoneNumber ? (
                    <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  ) : null}
                </div>
              </div>
              {errors.phoneNumber && touched.phoneNumber && (
                <p className="error-text text-red-500 text-sm mt-2 flex items-center gap-1">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  {errors.phoneNumber}
                </p>
              )}
              <p className="text-gray-400 text-xs mt-1 flex items-center gap-1">
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                Введите 9 цифр после +998 | Пример: +998901234567
              </p>
            </div>

            {/* Submit Button */}
            <div className="col-span-1 md:col-span-2 mt-4">
              <button
                onClick={handleSubmit}
                type="button"
                disabled={!isFormValid() || cart.length === 0}
                className={`submit-btn w-full md:w-auto px-12 py-4 rounded-xl text-lg font-bold text-white relative z-10 transition-all ${isFormValid() && cart.length > 0
                  ? "bg-purple-600 hover:bg-purple-700 cursor-pointer"
                  : "opacity-50 cursor-not-allowed bg-gray-500"
                  }`}
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
                  </svg>
                  Оформить заказ
                </span>
              </button>
              {(!isFormValid() || cart.length === 0) && (
                <p className="text-gray-400 text-sm mt-3">
                  Заполните все обязательные поля корректно и добавьте товары в корзину
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;